import { oauth, OAuth2Params } from './oauth';
import { $vars } from '../../config/vars';

export namespace $microsoft {
    let auth2_promise: Promise<string> | undefined;

    export function auth2() {
        if(!auth2_promise) {
            const params: OAuth2Params = {
                response_type: 'token',
                client_id: $vars.microsoft_api.client_id,
                redirect_uri: $vars.oauth_redirect,
                scope: 'Contacts.Read'
            }

            auth2_promise = oauth('https://login.live.com/oauth20_authorize.srf', params);
        }

        return auth2_promise;
    }
}
